// ============================================================
// תוכן האתר - ניתן לעריכה מלאה.
// כל הטקסטים, התמונות, ושמות הפרויקטים מוגדרים כאן.
// כדי להוסיף פרויקט חדש - פשוט הוסיפי אובייקט למערך projects.
// ============================================================

export const site = {
  // לוגו טקסטואלי - שני אותו לשם שלך כשרוצים
  brandName: "דפני.",
  brandTagline: "קופירייטינג ואסטרטגיית תוכן",
  email: "lifebyunicorn@gmail.com",
  phone: "054-4562234",
  cvUrl: "#", // החליפי בקישור ל-CV PDF
  socials: {
    instagram: "#",
    linkedin: "#",
  },
};

export const nav = [
  { label: "עבודות", href: "/#projects", testId: "nav-projects" },
  { label: "אודות", href: "/about", testId: "nav-about" },
  { label: "קורות חיים", href: "/cv", testId: "nav-cv" },
];

export const hero = {
  title: "בירקין זה נחמד\nאבל ניסיתם פעם\nתיק עבודות?",
  intro:
    "אני דפני, קופירייטרית ואסטרטגית תוכן.\nחוקרת את מה שמניע אנשים (יש קבלות), בונה שפות מותג שאי אפשר לפספס בגלילה ויוצרת תוכן חד, מכוון תוצאות ולא קלישאתי. עם הכשרה בקופיווייז, חיים שלמים בסושיאל ותשוקה לרעיונות שיפוצצו לכם את המוח - אני באה לתת עבודה. סיימתי לחפור, מוזמנים לגלות What's in my bag!",
  cta: "לעבודות",
};

// ============================================================
// פרויקטים - 10 פרויקטים בגריד Bento
// size קובע את גודל הכרטיס בגריד:
//   "lg" = 2x2, "wide" = 2x1, "tall" = 1x2, "sm" = 1x1
// variant: "image" / "type" / "accent"
// ============================================================

// ============================================================
// פרויקטים - 10 פרויקטים בגריד Bento (4 cols × 6 rows = 24 cells)
// size: "lg" = 2×2 (4) | "wide" = 2×1 (2) | "tall" = 1×2 (2) | "sm" = 1×1 (1)
// gridClass: מיקום מדויק בגריד למסכי md+
// variant: "image" / "type" / "accent"
// ============================================================

export const projects = [
  {
    slug: "monox-plus",
    title: "Monox+",
    category: "Event Copy",
    size: "lg",
    gridClass: "md:col-start-1 md:col-span-2 md:row-start-1 md:row-span-2",
    variant: "image",
    cover:
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/s1tm4fks_ChatGPT%20Image%20May%202%2C%202026%2C%2002_48_54%20PM.png",
    role: "Event Copy",
    myPart:
      "קופירייטרית (תחת חברת THM) - פיצוח קונספט, בחירת מוצרים וקופי.",
    challenge:
      "הלקוח ביקש ליצור סט מוצרים לשירות פרימיום חדש שהוא משיק.",
    solution:
      "רציתי לגרום לקהל היעד להרגיש שהוא חלק מקאנטרי קלאב אקסלוסיבי אז לקחתי את המושג ״מוצרים ממותגים״ והפכתי אותו לחלק מהנרטיב. אצרתי רשימת מוצרים מפתיעה שמתכתבת בול עם ה-DNA של המותג, והלבשתי עליהם קופי שנועד לעשות שני דברים במקביל: לדבר את שפת המותג, ולנהל דיאלוג מתוחכם עם המוצר עצמו.",
    gallery: [
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/21y28nj4_ChatGPT%20Image%20May%202%2C%202026%2C%2002_44_26%20PM.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/s1tm4fks_ChatGPT%20Image%20May%202%2C%202026%2C%2002_48_54%20PM.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/tua96xll_ChatGPT%20Image%20May%202%2C%202026%2C%2002_55_39%20PM.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/pquovrm7_ChatGPT%20Image%20May%202%2C%202026%2C%2002_58_23%20PM.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/rym32bct_ChatGPT%20Image%20May%202%2C%202026%2C%2003_05_37%20PM.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/1bw7ljqb_ChatGPT%20Image%20May%202%2C%202026%2C%2002_42_06%20PM.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/i3ir21ly_ChatGPT%20Image%20May%202%2C%202026%2C%2002_41_12%20PM.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/1qr7c4nu_ChatGPT%20Image%20May%202%2C%202026%2C%2002_41_04%20PM.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/gh848r33_ChatGPT%20Image%20May%202%2C%202026%2C%2002_30_27%20PM.png",
    ],
  },
  {
    slug: "talks",
    title: "Talks",
    category: "Brand Voice & Strategy",
    size: "sm",
    gridClass: "md:col-start-3 md:col-span-1 md:row-start-1 md:row-span-1",
    variant: "image",
    cover:
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/ek3irlv4_Instagram%20post%20-%201%20%281%29.png",
    role: "Brand Voice & Strategy",
    myPart:
      "קופירייטרית (תחת חברת THM) - אסטרטגיית מותג, טון & וויס וקריאייטיב.",
    challenge:
      "לקחת פודקאסט חדש בשם ״Talks״ ולברוא לו זהות, אופי ומקום ייחודי בשוק רווי בתוכן.",
    solution:
      "בניית מותג מאפס. הגדרת ה-Tone of Voice, זיקוק השפה המותגית, ופיצוח סלוגן המטרייה שליווה את ההשקה.",
    gallery: [
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/ek3irlv4_Instagram%20post%20-%201%20%281%29.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/tjocbfqp_Instagram%20post%20-%2010.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/xj0iclz3_Instagram%20post%20-%2011.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/i4anznf8_Instagram%20post%20-%2012.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/qfexw3di_Instagram%20post%20-%2014.png",
    ],
  },
  {
    slug: "pink",
    title: "Pink",
    category: "Strategy & Campaign",
    size: "sm",
    gridClass: "md:col-start-4 md:col-span-1 md:row-start-1 md:row-span-1",
    variant: "image",
    cover:
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/kb8gip7q_Instagram%20post%20-%2014%20%281%29.png",
    role: "Strategy & Campaign",
    myPart:
      "קופירייטרית ואסטרטגית (תחת חברת THM) - פיתוח אסטרטגיית קמפיין וקופי.",
    challenge:
      "מותג מערכות לקביעת תורים עובר ריברנדינג וצריך להסביר לשוק שהוא לא רק ״טכנולוגי״, הוא מגניב.",
    solution:
      "גיבוש אסטרטגיית קמפיין ממוקדת-שינוי. שמתי בפרונט בעלות עסקים קשישות ובאדאסיות שלא רק מושכות את העין אלא מעבירות את המסר שכל אחת יכולה. ככה תרגמתי את המהות החדשה של המותג לקופי חד, שמדבר על הערך האמיתי של המערכת בצורה חדשה ומבדלת כדי שלא יבלע בין כל המערכות המתחרות שמציפות את השוק.",
    gallery: [
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/kb8gip7q_Instagram%20post%20-%2014%20%281%29.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/ahew2yiw_Instagram%20post%20-%2015.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/q7nkpp66_Instagram%20post%20-%2016.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/1xxizk7d_pink_camp_Lifestyle_1.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/bn4ad510_pink_camp_Lifestyle_2.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/1d7y6g0k_pink_camp_Lifestyle_3.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/c66uv5ra_pink_camp_Product_1.png",
    ],
  },
  {
    slug: "true-story",
    title: "True Story",
    category: "Marketing Funnel",
    size: "wide",
    gridClass: "md:col-start-3 md:col-span-2 md:row-start-2 md:row-span-1",
    variant: "image",
    cover:
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/lb519k4l_Post_true%20story_Campagin%20rmaketing%203_2471_3.png",
    role: "Marketing Funnel",
    myPart:
      "קופירייטרית (תחת חברת THM) - ארכיטקטורת תוכן וכתיבת משפך המרות.",
    challenge:
      "לייצר סדרת קמפיינים שלא רק מביאה טראפיק, אלא מעבירה חוויה ומוליכה את הגולש יד ביד עד לרכישה.",
    solution:
      "תרגום של משפך שיווקי קלאסי (Funnel) לסדרת קופי המשכית שמדגישה את היתרונות של המוצרים ומדגישות אסתטיקה. כל מודעה וכל שלב בסדרה פוצחו בהתאם למצב המנטלי של הלקוח באותו רגע, החל משלב המודעות (Awareness), דרך השיקול (Consideration) ועד ה-Hook המכירתי בסוף.",
    gallery: [
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/lb519k4l_Post_true%20story_Campagin%20rmaketing%203_2471_3.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/jf81q5pf_Post_true%20story_Campagin%20rmaketing%203_2471_2.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/un8gz4t8_Post_true%20story_Campagin%20rmaketing%203_2471_1.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/xaf8hv3x_Post_true%20story_Campagin%20ao%203_2366_2.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/z96e65ry_Post%201_true%20story_Campagin%20ao%203_2366_3.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/63gao3pg_Post_true%20story_Campagin%20rmaketing%203_2471_4.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/58mcotq0_Post_true%20story_Campagin%20rmaketing%203_2471_5.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/3os5fgau_Post_true%20story_Campagin%20rmaketing%203_2471_6.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/tg64v5md_Post_true%20story_Campagin%20rmaketing%203_2471_7.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/lkspiyha_Post_true%20story_Campagin%20rmaketing%203_2471_8.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/l6q3000z_story_Gummies_true_%20defiancecam_5_v1.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/b6urprmg_story_premium_true_%20defiancecam_1_v1.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/xcem022j_story_recovery__true_%20defiancecam_3_v1.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/vq3ckosv_story_skny_true_%20defiancecam_2_v1.png",
    ],
  },
  {
    slug: "flormar",
    title: "Flormar",
    category: "Marketing Funnel",
    size: "wide",
    gridClass: "md:col-start-1 md:col-span-2 md:row-start-3 md:row-span-1",
    variant: "image",
    cover:
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/6bagkiwc_Instagram%20post%20-%2024.png",
    role: "Marketing Funnel",
    myPart:
      "קופירייטרית (תחת חברת THM) - כתיבת קמפיין משפך מבוסס קהלים.",
    challenge:
      "לייצר מהלך דיגיטלי מניע לפעולה עבור מותג איפור מוביל ומוכר, תוך שמירה על הסטייל והגלאם המותגי.",
    solution:
      "פיתוח סדרת קמפיינים מבוססת פאנל שיווקי, לכל ערכה חשבתי על ״אווירה״ שתלווה אותה ותיתן ויז׳ן ברור למתי אפשר להשתמש במוצרים. ביצעתי פיצוח מסרים דינמיים וויזואל קריאייטיבי שמלווה את הקולקציה, דרך יצירת ברייקדאון של יתרונות המוצרים, ועד לקופי מכירתי שמתכתב עם המשפך השיווקי וקהלי היעד.",
    gallery: [
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/6bagkiwc_Instagram%20post%20-%2024.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/7k6m2x5e_Instagram%20post%20-%2017.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/20yw1np9_Instagram%20post%20-%2010%20%281%29.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/9ywp172h_Instagram%20post%20-%201%20%282%29.png",
    ],
  },
  {
    slug: "green-fields",
    title: "Green Fields",
    category: "Newsletter Strategy",
    size: "tall",
    gridClass: "md:col-start-3 md:col-span-1 md:row-start-3 md:row-span-2",
    variant: "image",
    cover:
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/8nel0o8l_%D7%94%D7%93%D7%A8%20-%20%D7%91%D7%90%D7%A0%D7%A8%20%D7%A8%D7%90%D7%A9%D7%99%20%D7%9C%D7%A2%D7%9E%D7%95%D7%93%20%D7%9E%D7%A9%D7%A8%D7%95%D7%AA%20%20%D7%90%D7%95%D7%A4%D7%A6%D7%99%D7%94.jpg",
    role: "Newsletter Strategy",
    myPart:
      "קופירייטרית (תחת חברת THM) - בניית קונספט תוכן וכתיבת ניוזלטרים.",
    challenge:
      "לכתוב לחברת קנאביס רפואי בישראל, שוק עם מגבלות רגולציה קשוחות, שדורש שילוב עדין בין מקצועיות קלינית לבין חיבור אנושי בגובה העיניים.",
    solution:
      "בניית אסטרטגיית תוכן למערך הדיוור של החברה וכתיבת הניוזלטרים בפועל באופן לא ״סאחי״ ומעניין. יצירת שפה קולחת, מרתקת ומלמדת, שמצליחה לעקוף את ״המחסום הרפואי״ המשעמם ולהפוך את המייל של המותג לכזה שבאמת מחכים לפתוח.",
    galleryStyle: "newsletter",
    gallery: [
      {
        image: "/gallery/green-fields/newsnov.jpg",
        label: "ניוזלטר נובמבר",
        pdf: "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/3sokgblz_Green-Fields_newsnov_2324%20%281%29.pdf",
      },
      {
        image: "/gallery/green-fields/newsdec.jpg",
        label: "ניוזלטר דצמבר",
        pdf: "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/m9y8phdj_Green-Fields_newsdec_2570%20%281%29.pdf",
      },
      {
        image: "/gallery/green-fields/newsjan.jpg",
        label: "ניוזלטר ינואר",
        pdf: "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/mcrgd5gd_Green-Fields_newsjan_2611%20%281%29.pdf",
      },
    ],
  },
  {
    slug: "akadima-bar-ilan",
    title: "אקדימה בר אילן",
    category: "Social Creative",
    size: "tall",
    gridClass: "md:col-start-4 md:col-span-1 md:row-start-3 md:row-span-2",
    variant: "image",
    cover:
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/rga182gh_mr_akadima_test_2314_1.png",
    role: "Social Creative",
    myPart:
      "קופירייטרית (תחת חברת THM) - קריאייטיב וכתיבת פוסטים.",
    challenge:
      "לפנות למוחות צעירים (סטודנטים לעתיד) מטעם פרויקט ״אקדימה״ של אוניברסיטת בר-אילן, בלי להישמע כמו מוסד אקדמי מיושן.",
    solution:
      "סדרת פוסטים דינמית שמבוססת על משחקי מילים, אותיות וטיפוגרפיה. פיצחתי שפה ויזואלית-טקסטואלית שמתכתבת עם עולם האקדמיה באופן שתופס את העין של קהל היעד בגלילה מהירה בסושיאל.",
    gallery: [
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/rga182gh_mr_akadima_test_2314_1.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/chuq9a5j_akadima_test_2314_2.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/uqar6sx2_akadima_test_2314_3.png",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/hogwivwz_akadima_test_2314_4.png",
    ],
  },
  {
    slug: "niga",
    title: "ניגא",
    category: "Content Videos",
    size: "wide",
    gridClass: "md:col-start-1 md:col-span-2 md:row-start-4 md:row-span-1",
    variant: "image",
    cover:
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/8wfqljov_Nyga%20Blue%20-%20Copy.jpg",
    role: "Content Videos",
    myPart:
      "קופירייטרית (תחת חברת THM) - תסריטאות ופיתוח סדרת תוכן הומוריסטית.",
    challenge:
      "לגרום לאנשים לרצות לצפות בתוכן מרתק על... טוחני אשפה.",
    solution:
      "כתיבת סדרת סרטוני רשת מבוססת אסטרטגיה הומוריסטית. במקום לדבר על מנועים וכוחות סוס, לקחתי מיתוסים ותרגמתי אותן לתסריטים משעשעים ששוברים מוסכמות מקובלות והופכים את טוחן האשפה לכוכב הבלתי מעורער של הבית.",
    gallery: [
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/si1asusr_%D7%9E%D7%99%D7%AA%D7%95%D7%A1%201.mp4",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/aidsil9j_%D7%9E%D7%99%D7%AA%D7%95%D7%A1%202.mp4",
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/cxv8lc45_%D7%9E%D7%99%D7%AA%D7%95%D7%A1%203.mp4",
    ],
  },
  {
    slug: "ceremony",
    title: "Ceremonie",
    category: "Organic Creative",
    size: "lg",
    gridClass: "md:col-start-1 md:col-span-2 md:row-start-5 md:row-span-2",
    variant: "image",
    cover:
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/x6cih6gc_logo%203333%201.png",
    role: "Organic Creative",
    myPart:
      "קופירייטרית (תחת חברת THM) - קונספט ותסריט.",
    challenge:
      "לייצר אימפקט דיגיטלי משמעותי עבור מותג התה ״סרמוני״ ללא תקציב מדיה ממומן.",
    solution:
      "סרטון קריאייטיבי שנשען על אחת התובנות (Insights) האנושיות והמצחיקות ביותר: ״מתנה לחמות״. כתיבת תסריט חד, מבוסס הומור עצמי ומודעות, שהצליח לפצח את האלגוריתם, לעלות באורגני ולייצר מעורבות גבוהה בזכות זיהוי מדויק של קהל היעד.",
    gallery: [
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/bilk0l1m_%D7%A1%D7%A8%D7%9E%D7%95%D7%A0%D7%99_2252_1%20%D7%97%D7%9E%D7%95%D7%AA%20%D7%92%D7%91%D7%A8%D7%99%20%D7%97%D7%93%D7%A9_V2.mp4",
    ],
  },
  {
    slug: "clalit-innovation",
    title: "כללית חדשנות",
    category: "60 Seconds Campaign",
    size: "lg",
    gridClass: "md:col-start-3 md:col-span-2 md:row-start-5 md:row-span-2",
    variant: "image",
    cover:
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/x2jbc8ba_%D7%9C%D7%95%D7%92%D7%95%20%D7%A2%D7%95%D7%A9%D7%99%D7%9D%20%D7%97%D7%93%D7%A9%D7%A0%D7%95%D7%AA%20.jpeg",
    role: "60 Seconds Campaign",
    myPart:
      "קופירייטרית (תחת חברת THM) - התאמת קונספט וכתיבת תוכן.",
    challenge:
      "להנגיש את פרויקט ״מאתגר לפתרון״ של כללית חדשנות (נושא מורכב, טכנולוגי ורפואי) בצורה קלילה, מהירה ומזמינה.",
    solution:
      "״השאלה״ של פורמט ה-60 שניות הטרנדי מהרשתות החברתיות והלבשתו על עולם החדשנות הרפואית. כתבתי שאלות מהירות, חדות וקצביות שהניעו את המשתתפים לחשוב מהר, הפכו את האתגר למשחק, וקירבו את עולם החדשנות של כללית לקהל הרחב.",
    gallery: [
      "https://customer-assets.emergentagent.com/job_bold-creative-11/artifacts/952flqau_%D7%A2%D7%95%D7%AA%D7%A7%20%D7%A9%D7%9C%20%D7%9B%D7%9C%D7%9C%D7%99%D7%AA_3078_60%20%D7%A9%D7%A0%D7%99%D7%95%D7%AA%20%D7%90%D7%95%D7%A8.mp4%20v2.mp4",
    ],
  },
];

export const about = {
  pageTitle: "דף אודות",
  pageSubtitle: "קו״ח",
  contact: {
    email: "lifebyunicorn@gmail.com",
    emailNote: "(לא לצחוק עליי, פתחתי את המייל ביסודי).",
    phone: "054-4562234",
  },
  sectionLabel: "קצת על עצמי:",
  storyHeadline: "כמה מילים עלי",
  storyHeadlineSub: "(והרבה על העיר הכי טובה ביקום)",
  story: [
    {
      type: "paragraph",
      text: "איך הגעתי לפרסום? בטעות, ובזכות כפר סבא. יש לי אובססיה לא לגמרי בריאה לעיר כפר סבא (בדקתי ב-DSM, זו לא הפרעה נפשית רשמית). יצרתי עמוד Memes כאות הערכה לעיר (הכי טובה בעולם) שהתפוצץ ותוך שבועיים עקף את הסושיאל של העירייה, מה שהוביל לסכסוך מתוקשר עם ראש העיר. הסיפור הזה הפך אותי רשמית לאסטרטגית תוכן: כתבתי קמפיין בחירות למועמד למועצה, ומשם הדרך ל-THM הייתה קצרה.",
    },
    {
      type: "paragraph",
      text: "בתוך פחות מחצי שנה כמנהלת סושיאל ב-THM קודמתי לתפקיד קופירייטרית. פיצחתי, כתבתי וניהלתי עשרות פרויקטים, מניוזלטרים ועד קמפייני פאנל מורכבים. היום, כשאני אוטוטו בוגרת קורס קופי בקופיווייז, אני מביאה איתי שילוב של הבנה פסיכולוגית עמוקה, ניסיון שטח אמיתי, ויכולת מוכחת להפוך מילים לביזנס.",
    },
    {
      type: "paragraph",
      text: "בנוסף, את התואר שלי עשיתי בפסיכולוגיה ותקשורת בבן גוריון (סיימתי בהצטיינות, תודה ששאלתם), מתוך תשוקה להבין מה מניע אנשים, מה גורם להם להרגיש ואיך מפצחים את ההתנהגות האנושית. אבל את הסטאז' האמיתי שלי עשיתי ברשת.",
    },
    {
      type: "paragraph",
      text: "משהו קטן עלי: אני חיה ונושמת סושיאל (מלימונים ועד הפשוטע) ומגדלת בגאווה כלבה עזתית שחילצתי בעצמי כי אם אני מאמינה במשהו, שום מחסום לא יעצור אותי. באתי לעבוד, לרגש, ולהשאיר אתכם פעורי פה.",
    },
  ],
};

export const cv = {
  profile: {
    name: "תמר דפני",
    role: "קופירייטרית ויוצרת תוכן",
    phone: "054-4562234",
    email: "lifebyunicorn@gmail.com",
  },
  summary: {
    title: "תמצית מקצועית",
    text: "קופירייטרית ויוצרת תוכן בעלת ניסיון מוכח במשרדי פרסום דיגיטליים, ניהול קמפיינים פוליטיים ובניית מותגים ויראליים. מביאה שילוב ייחודי של הבנה פסיכולוגית מעמיקה (תואר ראשון בפסיכולוגיה ותקשורת) יחד עם שליטה בכלי AI מתקדמים לכתיבה ועיצוב. מומחית בפיצוח שפה מותגית, כתיבה שיווקית וקריאייטיב מניע לפעולה.",
  },
  sections: [
    {
      title: "ניסיון מקצועי",
      items: [
        {
          role: "קופירייטרית",
          place: "משרד הפרסום הדיגיטלי רייזמדיה THM",
          period: "מאי 2025 – היום",
          bullets: [
            "כתיבת קופי שיווקי וקריאייטיב למגוון לקוחות המשרד בדיגיטל.",
            "פיתוח קונספטים לקמפיינים, כתיבת תסריטים לוידאו, ניסוח מודעות ופוסטים לרשתות החברתיות.",
            "עבודה מול צוותי עיצוב ואסטרטגיה לדיוק המסר הפרסומי.",
          ],
        },
        {
          role: "יוצרת תוכן עצמאית ויועצת סושיאל",
          place: "",
          period: "2022 – היום",
          bullets: [
            'הקמה וניהול עמוד הממים "Kfarsababa": צמיחה אורגנית ל-5,000 עוקבים תוך שבועיים דרך תוכן ויראלי ושפה מותגית ייחודית.',
            "אסטרטגיית תוכן וקריאייטיב: הובלת תהליכי קריאייטיב מהרעיון ועד הביצוע, כולל שימוש באנליטיקה לשיפור ביצועים.",
          ],
        },
        {
          role: "קופירייטרית ואסטרטגית תוכן",
          place: "קמפיין הבחירות של נדב לויטה",
          period: "2023",
          bullets: [
            "כתיבה שיווקית וקריאטיבית לקמפיין הבחירות המוניציפליות בכפר סבא.",
            'פיתוח שפה תקשורתית מותאמת לרשתות החברתיות וניסוח מסרים לקהלים מגוונים תחת לו"ז צפוף.',
          ],
        },
        {
          role: "מנהלת סניף באר שבע",
          place: 'תנועת "סבבתא"',
          period: "2022 – 2023",
          bullets: [
            "ניהול תוכן דיגיטלי, תכנון והפקת חומרים ויזואליים (פוסטים ופליירים) וכתיבה שיווקית לאירועים.",
          ],
        },
        {
          role: "כותבת תוכן",
          place: '"נותנים מילה"',
          period: "2020",
          bullets: [
            "כתיבה שיווקית ועריכת מאמרים בתחומים מגוונים עבור אתרי תוכן.",
          ],
        },
      ],
    },
    {
      title: "השכלה והכשרה מקצועית",
      items: [
        {
          role: "קורס קופירייטינג",
          place: "Copywise",
          period: "2026",
          bullets: ["הכשרה מקצועית מתקדמת בקריאייטיב וכתיבה פרסומית."],
        },
        {
          role: "תואר ראשון (B.A) בתקשורת ופסיכולוגיה",
          place: "אוניברסיטת בן-גוריון",
          period: "2021 – 2024",
          bullets: ["סיום בממוצע 95."],
        },
        {
          role: "בגרות מלאה",
          place: 'תיכון "רבין" כפר-סבא',
          period: "",
          bullets: ["סיום בהצטיינות, ממוצע 110.7."],
        },
      ],
    },
    {
      title: "כישורים טכנולוגיים וכלים",
      items: [
        {
          role: "כלי AI",
          place: "",
          period: "",
          bullets: [
            "שליטה מלאה ב-ChatGPT, Manus, Suno, Preplexity, Gemini, Claude, Midjourney לצרכי קריאייטיב ויצירת תוכן.",
          ],
        },
        {
          role: "עיצוב ודיגיטל",
          place: "",
          period: "",
          bullets: [
            "Canva (עיצוב גרפי בסיסי), ניהול עמודי סושיאל ואנליטיקה.",
          ],
        },
        {
          role: "שפות",
          place: "",
          period: "",
          bullets: ["עברית (שפת אם), אנגלית (רמה גבוהה מאוד)."],
        },
      ],
    },
    {
      title: "ניסיון נוסף וקהילה",
      items: [
        {
          role: "ניהול סושיאל (בהתנדבות)",
          place: "העמותה לשימור כפר סבא",
          period: "2025",
          bullets: [],
        },
        {
          role: "רקע טיפולי",
          place: "מכון פוירשטיין",
          period: "2019 – 2024",
          bullets: [
            "ניסיון כמשקמת קוגניטיבית — פיתוח יכולת הקשבה, זיקוק מסרים מורכבים והתאמתם לקהלי יעד שונים.",
          ],
        },
      ],
    },
  ],
};

export const contact = {
  big: "דברו איתי",
  sub: "פרויקט בראש? שאלה? עניין כללי? אני קוראת כל מייל.",
  email: "hello@example.com",
  social: [
    { label: "Instagram", href: "#" },
    { label: "LinkedIn", href: "#" },
    { label: "Email", href: "mailto:hello@example.com" },
  ],
};
